import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";

import MDTypography from "@/components/atoms/MDTypography";
import { WorkflowEditDialogMessages } from "@/messages/workflow/workflow-edit-dialog.messages";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  messages: WorkflowEditDialogMessages;
};

export default function ProductSearchAssertivenessModal({ isOpen, onClose, messages }: Props) {
  return (
    <Dialog open={isOpen} onClose={onClose} sx={{ p: 2 }} maxWidth="md">
      <DialogTitle>{messages.productSearchAssertivenessLabel}</DialogTitle>
      <DialogContent>
        <MDTypography variant="body2" color="text" sx={{ whiteSpace: "pre-line" }}>
          {messages.productSearchAssertivenessTooltip}
        </MDTypography>
      </DialogContent>
    </Dialog>
  );
}
